import React from 'react';
import Logo from '../Logo';

const rows = [
  {
    capability: 'Channel Operation',
    others: 'One channel at a time',
    us: 'Voice + SMS + WhatsApp + email simultaneously',
  },
  {
    capability: 'Staff Coordination',
    others: 'Not supported',
    us: 'Real-time SMS bridge during live calls',
  },
  {
    capability: 'Manager Instructions',
    others: 'Dashboard only',
    us: 'Call or text to update operations instantly',
  },
  {
    capability: 'Knowledge Grounding',
    others: 'Prompt engineering',
    us: 'Human-verified FAQ with source attribution',
  },
  {
    capability: 'Testing',
    others: 'Deploy first, fix later',
    us: 'Automated regression testing before deployment',
  },
  {
    capability: 'Production Operations',
    others: 'Alert dashboards and manual triage',
    us: 'Every call validated, issues detected and resolved in minutes',
  },
  {
    capability: 'Quality Improvement',
    others: 'Manual prompt tuning',
    us: 'AI-powered gap detection from real conversations',
  },
  {
    capability: 'Infrastructure',
    others: 'Shared multi-tenant',
    us: 'Dedicated ECS, Redis, and DynamoDB per account',
  },
  {
    capability: 'Scale',
    others: 'Rate-limited API wrappers',
    us: '300 simultaneous calls, sub-800ms latency',
  },
];

const Comparison = () => {
  return (
    <div className="px-8 py-20 bg-neutral-800">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
            Built for Production, Not Demos
          </h2>
          <p className="!text-stone-300 text-lg font-medium font-['Inter']">
            Most platforms give you a chatbot wrapper. We give you an autonomous employee with its own infrastructure.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full bg-neutral-900 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-neutral-700">
                <th className="text-left p-4 !text-white text-sm font-bold font-['Montserrat']">Capability</th>
                <th className="text-center p-4 !text-stone-300 text-sm font-bold font-['Montserrat']">Other Platforms</th>
                <th className="text-center p-4 !text-blue-400 text-sm font-bold font-['Montserrat']">
                  <center><Logo height="22" /></center>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={row.capability} className={`border-t border-neutral-700 ${index % 2 === 0 ? 'bg-neutral-800/50' : ''}`}>
                  <td className="p-4 !text-stone-300 text-sm font-medium font-['Inter']">{row.capability}</td>
                  <td className="p-4 text-center">
                    <span className="text-stone-400 text-sm font-['Inter']">{row.others}</span>
                  </td>
                  <td className="p-4 text-center">
                    <span className="text-blue-400 text-sm font-bold font-['Inter']">{row.us}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Comparison;
